import React from "react";
import {View} from "@unibuddy/patron";
import {useTranslation} from "@unibuddy/intl";

import {AuthPageContainer} from "../components/AuthPageContainer";
import {PageTitle} from "../../../../components/PageTitle/PageTitle";
import {LoginPageHeading} from "../components/LoginPageHeading";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_LOGIN} from "../../../../translations/login";
import {LoginPageContent} from "../components/LoginPageContent";
import {CookieSettings} from "../../../../widgets/shared/components/CookieSettings/CookieSettings";

export function LoginPage() {
    const {t} = useTranslation(IntlNamespaces.LOGIN);

    return (
        <View alignItems="center" gap="small">
            <AuthPageContainer>
                <PageTitle title={t(INTL_LOGIN.key, INTL_LOGIN.defaultValue)} />
                <LoginPageHeading />
                <LoginPageContent />
            </AuthPageContainer>
            <CookieSettings />
        </View>
    );
}
